import SectionLabel from "./SectionLabel";
import { FadeUp, MaskLine } from "./Reveal";
import { WMWE_URL } from "@/lib/site";

const finalLines = [
  "Pause.",
  "Assess.",
  "Gather.",
  "Listen.",
  "Ask better questions.",
  "Pay attention to what has changed.",
  "Recognize what you don't know.",
  "Consider the intelligence already around you.",
  "Listen for what Heaven is saying.",
];

const footerBits = [
  "A WMWE SIGNATURE GATHERING",
  "RECON 2026 // THE BRIEFING",
  "INTELLIGENCE REQUIRED BEFORE MOVEMENT",
  "PAUSE // ASSESS // GATHER // MOVE",
  "THE ROOM IS A RESOURCE",
  "YOUR NEXT MOVE DESERVES INTELLIGENCE",
];

const barcode = [3, 1, 2, 1, 1, 3, 1, 2, 4, 1, 1, 2, 1, 3, 2, 1, 1, 1, 4, 2, 1, 3, 1, 1, 2, 1, 3, 1, 2, 2, 1, 4, 1, 1, 3, 1, 2];

export default function FinalInvite() {
  return (
    <section data-testid="final-section" className="bg-bone">
      <div className="mx-auto max-w-7xl px-6 py-28 md:px-10 md:py-40">
        <SectionLabel testid="final-label">Final Brief</SectionLabel>

        <h2 className="font-serif text-4xl font-medium leading-[1.05] tracking-tight text-ink sm:text-5xl lg:text-6xl">
          <MaskLine>Before you make</MaskLine>
          <MaskLine delay={0.1}>
            <span className="italic text-wine">your next move...</span>
          </MaskLine>
        </h2>

        <div className="mt-16 grid gap-14 lg:grid-cols-2">
          <div className="space-y-1">
            {finalLines.map((line, i) => (
              <FadeUp key={line} delay={i * 0.06} y={20}>
                <p className="font-serif text-2xl leading-snug text-ink/85 md:text-3xl">{line}</p>
              </FadeUp>
            ))}
            <FadeUp delay={0.6}>
              <p className="pt-4 font-serif text-3xl italic text-oxblood md:text-4xl">
                And then — move.
              </p>
            </FadeUp>
          </div>

          <FadeUp delay={0.25}>
            <div className="border border-ink/30 bg-manila p-10 md:p-14">
              <p className="font-sans text-[10px] tracking-[0.4em] text-ink/50">
                A WMWE SIGNATURE GATHERING
              </p>
              <p className="mt-6 font-serif text-5xl font-medium tracking-tight text-ink md:text-6xl">
                RECON <span className="text-oxblood">2026</span>
              </p>
              <p className="mt-3 font-sans text-xs tracking-[0.5em] text-ink">THE BRIEFING</p>
              <p className="mt-8 font-serif text-xl italic text-ink/80">
                Before your next move, gather intelligence.
              </p>
              <a
                href="/checkout"
                data-testid="final-cta-button"
                className="group relative mt-10 inline-flex items-center overflow-hidden border border-wine bg-wine px-10 py-5 font-sans text-xs tracking-[0.4em] text-bone"
              >
                <span className="absolute inset-0 translate-y-full bg-navy transition-transform duration-500 ease-out group-hover:translate-y-0" />
                <span className="relative">GET YOUR BRIEFING</span>
                <span className="relative ml-4 inline-block transition-transform duration-300 group-hover:translate-x-1.5">
                  →
                </span>
              </a>
            </div>
          </FadeUp>
        </div>
      </div>

      <footer data-testid="site-footer" className="border-t border-ink/20">
        <div className="mx-auto max-w-7xl px-6 py-12 md:px-10">
          <div className="flex flex-col gap-8 md:flex-row md:items-end md:justify-between">
            <div className="grid gap-2">
              <img
                src="/assets/wmwe-logo-dark.png"
                alt="WMWE — Run to the Table"
                className="mb-4 h-16 w-16 rounded-full border border-ink/15 bg-cream object-contain p-1.5"
              />
              {footerBits.map((bit) => (
                <p key={bit} className="font-sans text-[9px] tracking-[0.3em] text-ink/45">
                  {bit}
                </p>
              ))}
              <a
                href={WMWE_URL}
                target="_blank"
                rel="noreferrer"
                data-testid="footer-wmwe-link"
                className="mt-3 font-sans text-[9px] tracking-[0.3em] text-wine underline underline-offset-4"
              >
                VISIT WMWE AT THE CONNECTION GURU →
              </a>
            </div>
            <div className="flex flex-col items-start gap-3 md:items-end">
              <div aria-hidden="true" className="flex h-8 items-end gap-[2px]">
                {barcode.map((w, i) => (
                  <span key={i} className="bg-ink" style={{ width: `${w}px`, height: "100%" }} />
                ))}
              </div>
              <p className="font-sans text-[9px] tracking-[0.3em] text-ink/45">
                © 2026 WMWE — WE MEET WE EAT // GET BRIEFED
              </p>
            </div>
          </div>
        </div>
      </footer>
    </section>
  );
}
